import React from "react";
import { Switch, Route } from "react-router-dom";
import { PeopleOutline, AssessmentOutlined } from "@material-ui/icons";

import * as ROUTES from "../../constants/routes";
import { withAuthorization } from "../Session";
import { DashboardLayout } from "../UI";
import AdminCompanies from "./AdminCompanies";
import Reports from "./Reports";

const NAV_ITEMS = [
  {
    label: "Companies",
    icon: <PeopleOutline />,
    route: ROUTES.ADMINDASHBOARDHOME,
  },
  {
    label: "Reports",
    icon: <AssessmentOutlined />,
    route: ROUTES.ADMINDASHBOARDREPORTS,
  },
];

const AdminDashboard = () => (
  <DashboardLayout navItems={NAV_ITEMS}>
    <Switch>
      <Route path={ROUTES.ADMINDASHBOARDHOME} component={AdminCompanies} />
      <Route path={ROUTES.ADMINDASHBOARDREPORTS} component={Reports} />
      <Route exact path={ROUTES.ADMINDASHBOARD} component={AdminCompanies} />
    </Switch>
  </DashboardLayout>
);

const condition = (authUser) => {
  return !!authUser.claims && !!authUser.claims.superUser;
};

export default withAuthorization(
  condition,
  ROUTES.USERDASHBOARD
)(AdminDashboard);
